const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolisBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "polis",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.31 93.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "ee479e3f-0ea4-4327-95c8-5e0230a0c320",
    "data-name": "border",
    d: "M19,30.88c-2.39-1.68-4.6-6.67-2.67-10.72S25.67,10.62,26.5,9.75s.41-4.92.39-7.29S33.7-.24,36.47.84,39,8.39,38.94,10s3.21.95,7.31.68,5.61-2.07,8.21-2S60.4,10.73,63,10.3,66,8.4,76,7.37s29.55-1.83,30-.91a5.59,5.59,0,0,0,5.46,2.48c3-.35,5.31-5.4,11-6.12s5.35,3.41,5.13,6.93c-.18,2.75,3.15,1.43,4.5,2.87s4.83,12.84,5.74,17.81a75,75,0,0,1,1.09,9h6.2s1.44,26.78,2.16,30.48,1.7,10.5-.65,11.54S102.73,91.54,97,92.7s-13.29.09-14.46-1.86S76.76,86.14,71.2,86s-16.39-2.35-20.59-4.55S29.29,76.25,25.19,76.8s-8.84-2-12.43-4S2.42,69.06,1,65.29s-.45-15,.4-16.24.68-6,2.55-8.13,17.2-6.6,17.2-6.6C22.67,33.1,21.38,32.57,19,30.88Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolisBorder);
export default __webpack_public_path__ + "static/media/polis-border.6d7e867cd8de86cd8ad2e20cc470e6ae.svg";
export { ForwardRef as ReactComponent };